@for (warning of warnings; track warning) {
  <div class="alert alert-warning mt-3 col-12">
    <div [innerHTML]="warning.infoText">
    </div>
  </div>
}
